'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _extends = require('@babel/runtime/helpers/extends');
var React = require('react');
var nthBitHeader = require('@narvar/nth-bit-header');
var Paragraph = require('@narvar/nth-bit-paragraph');
var nthHookTheme = require('@narvar/nth-hook-theme');
var Box = require('../layout/Box/Box.js');
var DetailsCard_module = require('./DetailsCard.module.css.js');
var clsx = require('clsx');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var Paragraph__default = /*#__PURE__*/_interopDefaultLegacy(Paragraph);
var clsx__default = /*#__PURE__*/_interopDefaultLegacy(clsx);

const DetailsCardContainer = _ref => {
  let {
    layout,
    s,
    children
  } = _ref;
  const className = clsx__default["default"]({
    [DetailsCard_module["default"].container]: true,
    [DetailsCard_module["default"].vertical]: layout === 'vertical'
  });
  return /*#__PURE__*/React__default["default"].createElement(Box["default"], {
    gap: 4,
    display: "flex",
    className: className,
    style: s
  }, children);
};
const DetailsCardAttribute = _ref2 => {
  let {
    children
  } = _ref2;
  return /*#__PURE__*/React__default["default"].createElement(Paragraph__default["default"], {
    containerCustomStyle: {
      overflowWrap: 'break-word',
      margin: 0
    }
  }, children);
};
const DetailsCardAttributesContainer = _ref3 => {
  let {
    wideGap,
    children,
    s,
    ...rest
  } = _ref3;
  return /*#__PURE__*/React__default["default"].createElement(Box["default"], _extends__default["default"]({
    display: "flex",
    gap: wideGap ? 2 : 1,
    className: DetailsCard_module["default"].attributesContainer,
    style: s
  }, rest), children);
};
const DetailsCardLeftColumn = _ref4 => {
  let {
    children,
    ...rest
  } = _ref4;
  return /*#__PURE__*/React__default["default"].createElement("div", rest, children);
};
const DetailsCardRightColumn = _ref5 => {
  let {
    children
  } = _ref5;
  return /*#__PURE__*/React__default["default"].createElement(DetailsCardAttributesContainer, {
    wideGap: true,
    s: {
      flex: '1 0 0'
    }
  }, children);
};
const DetailsCardHeader = _ref6 => {
  let {
    children,
    s
  } = _ref6;
  return /*#__PURE__*/React__default["default"].createElement(nthBitHeader.SmallHeader, {
    containerCustomStyle: s
  }, children);
};
const DetailsCardStrongTextRoot = _ref7 => {
  let {
    children,
    s
  } = _ref7;
  const {
    bodytextDefaultNone
  } = nthHookTheme.useTheme();
  return /*#__PURE__*/React__default["default"].createElement("p", {
    style: {
      ...bodytextDefaultNone,
      fontWeight: 'bold',
      margin: 0,
      ...s
    }
  }, children);
};
const DetailsCardStrongText = nthHookTheme.withThemeProvider(DetailsCardStrongTextRoot, {
  themeTokens: ['bodytextDefaultNone']
});

exports.DetailsCardAttribute = DetailsCardAttribute;
exports.DetailsCardAttributesContainer = DetailsCardAttributesContainer;
exports.DetailsCardContainer = DetailsCardContainer;
exports.DetailsCardHeader = DetailsCardHeader;
exports.DetailsCardLeftColumn = DetailsCardLeftColumn;
exports.DetailsCardRightColumn = DetailsCardRightColumn;
exports.DetailsCardStrongText = DetailsCardStrongText;
